import fifthaveClient from './fifthaveClient';

export function getSizeChartList({brandId, categoryId, from, to}) {
    return fifthaveClient.get(`/api/v1/_internal/sizecharts/page?${brandId.map((n, index) => `brandId=${n}`).join('&')}`, {
        params: {
            categoryId,
            from,
            to
        }
      })
}

export function copySizeCharts(brandId, sourceCategory, newCategories) {
    return fifthaveClient.post(`/api/v1/_internal/sizecharts/copy/${brandId}/${sourceCategory}`, [...newCategories]);
}

export function deleteSizeChart(brandId, categoryId) {
    return fifthaveClient.delete(`/api/v1/_internal/sizecharts/${brandId}/${categoryId}`)
}

export function getSizeChart(brandId: string, categoryId: string) {
    return fifthaveClient.get(`/api/v1/_internal/sizecharts/${brandId}/${categoryId}`)
}

export function addSizeChart(brandId: string, categoryIds: string[], tables: any[]) {
    return fifthaveClient.post(`/api/v1/_internal/sizecharts/add`, {
        brand: brandId,
        categoryIds: categoryIds,
        tables: tables,
    })
}

export function updateSizeChart(sizeChartId: string, brandId?: string, categoryIds?: string[], tables?: any[]) {
    return fifthaveClient.put(`/api/v1/_internal/sizecharts/update/${sizeChartId}`, {
        brand: brandId,
        categoryIds: categoryIds,
        tables: tables,
    })
}

export function deleteSizeChartById(sizeChartId: string) {
    return fifthaveClient.delete(`/api/v1/_internal/sizecharts/deleteById/${sizeChartId}`)
}

export function getSizeChartById(sizeChartId: string) {
    return fifthaveClient.get(`/api/v1/_internal/sizecharts/${sizeChartId}`)
}
